'use strict'

import ApiClient from './ApiClient'

export default class PvNisfaIntegrationRepository {
  /**
   * 個人SFA連携設定の取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/personal-settings/nisfa-integration`)
  }

  /**
   * 個人SFA連携設定の更新
   * @param {Object} params 登録情報
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/personal-settings/nisfa-integration`, params)
  }

  /**
   * NISFA連携先へのログイン（接続テスト）
   * @param {Object} data TODO
   * @returns {*}
   */
  login (data) {
    return ApiClient().post(`/personal-settings/nisfa-integration/login`, data)
  }

  /**
   * SFA連携の実行
   * @param sid_persons
   * @returns {*}
   */
  execute (sid_persons) {
    return ApiClient().post(`/personal-settings/nisfa-integration/execute`, { ids: sid_persons })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/PvNisfaIntegrationRepository.js